import React, { useRef, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './date_picker_customized.component.css';
import { getMonth, getYear } from 'date-fns';
import _ from 'lodash';

const DatePickerCustomized = (props) => {
  const minDate = useRef(null);
  const years = useRef([]);
  const currentYear = useRef(null);
  const [months, setMonths] = useState([]);

  useEffect(() => {
    minDate.current = props.minDate ? new Date(props.minDate) : null;
    years.current = _.range(
      getYear(new Date()),
      minDate.current ? getYear(minDate.current) - 1 : 2007,
      -1,
    );
    currentYear.current = years[0];
    const currentMonth = getMonth(new Date());
    if (getYear(minDate.current) == getYear(new Date())) {
      const initMonth = getMonth(minDate.current);
      setMonths(monthsList.slice(initMonth, currentMonth + 1));
      return;
    }
    setMonths(monthsList.slice(0, currentMonth + 1));
  }, [props.minDate]);

  const updateMonths = (year) => {
    currentYear.current = year;
    const currentMonth = getMonth(new Date());
    if (minDate.current) {
      if (year == getYear(minDate.current)) {
        const initMonth = getMonth(minDate.current);
        setMonths(monthsList.slice(initMonth));
        return;
      }
    }

    if (parseInt(year) == getYear(new Date())) {
      setMonths(monthsList.slice(0, currentMonth + 1));
    } else {
      setMonths(monthsList);
    }
  };

  const monthsList = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return (
    <DatePicker
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="datePicker-header">
          <button
            onClick={() => {
              const [currentYear, currentMonth] = [
                getYear(date),
                getMonth(date),
              ];
              const initYear = getYear(minDate.current);
              if (
                (currentYear - 1 == initYear && currentMonth == 0) ||
                (currentYear == getYear(new Date()) && currentMonth == 0)
              ) {
                updateMonths(currentYear - 1);
              }
              decreaseMonth();
            }}
            disabled={prevMonthButtonDisabled}
            className="datePicker-nav prev absolute-center"
          ></button>
          <select
            onFocus={(e) => {
              e.target.size = '10';
              e.target.classList.add('focused');
            }}
            onBlur={(e) => {
              e.target.size = '1';
              e.target.classList.remove('focused');
            }}
            className="year-dropdown absolute-center"
            value={getYear(date)}
            onChange={(e) => {
              changeYear(e.target.value);
              updateMonths(e.target.value);
              const initMonth = getMonth(minDate.current);
              const currentMonth = getMonth(date);
              const maxMonth = getMonth(new Date());
              if (e.target.value == getYear(minDate.current)) {
                if (currentMonth < initMonth) {
                  changeMonth(initMonth);
                }
              }
              if (e.target.value == getYear(new Date())) {
                if (currentMonth > maxMonth) {
                  changeMonth(maxMonth);
                }
              }
              e.target.size = '1';
              e.target.classList.remove('focused');
              e.target.blur();
            }}
          >
            {years.current.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <select
            className="month-dropdown absolute-center"
            value={monthsList[getMonth(date)]}
            onChange={({ target: { value } }) => {
              changeMonth(monthsList.indexOf(value));
            }}
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button
            onClick={() => {
              const [currentYear, currentMonth] = [
                getYear(date),
                getMonth(date),
              ];
              const initYear = getYear(minDate.current);
              if (
                (currentYear == initYear && currentMonth == 11) ||
                (currentYear == getYear(new Date()) - 1 && currentMonth == 11)
              ) {
                updateMonths(currentYear + 1);
              }
              increaseMonth();
            }}
            disabled={nextMonthButtonDisabled}
            className="datePicker-nav next absolute-center"
          ></button>
        </div>
      )}
      inline={props.inline ? true : false}
      calendarClassName={props.calendarClassName}
      selected={props.selected}
      onSelect={(d) => props.onSelect(d)}
      onChangeRaw={(e) => {
        if (props.onChangeRaw) props.onChangeRaw(e, minDate.current);
      }}
      onBlur={() => props.onBlur && props.onBlur()}
      placeholderText={props.type === 'SELL' ? 'Selling Date' : 'Purchase Date'}
      dateFormat="dd-MM-yyyy"
      maxDate={new Date()}
      minDate={minDate.current}
      className={`add-tx-date-input ${props.inputClass}`}
      portalId="calendar-portal"
      disabled={props.isDisabled ? true : false}
      popperModifiers={{
        preventOverflow: {
          boundariesElement: 'viewport',
        },
      }}
    />
  );
};

export default DatePickerCustomized;
